<script>
import PInput from "../components/p-input";
import PCard from "../components/p-card";
import authService from "../services/auth";
import { validate } from "../utils";
import notificationService from "../plugins/notify";
import getConstants from "../services/getConstants";

const isTestExpired = (message) => message == 'TEST_EXPIRED';

const isLicenseExpired = (message) => message == 'LICENSE_EXPIRED';

export default {
    name: "Login",
    components: {
        PInput,
        PCard,
    },
    data() {
        return {
            form: {},
            errors: {},
            success: false,
            submitDisabled: false,
            forgotDisabled: false,
            resetDisabled: false,
            forgot: {
                identifier: ""
            },
            resetForm: {
                password: "",
                passwordConfirm: ""
            },
            resetToken: "",
            forgotMode: false,
            resetMode: false
        };
    },
    methods: {
        async submit(e) {
            this.submitDisabled = true;
            this.errors = validate(e);
            if (!!Object.keys(this.errors).length) {
                this.submitDisabled = false;
                return
            }
            
            try {
                const data = await authService.login(this.form);
                this.success = true;
                this.reset(e);
                setTimeout(function(){
                    window.location.assign('/index.php');
                }, 200);
            } catch (error) {
                this.reset(e);
                if(isTestExpired(error.data.message)) {
                    return window.location.assign('/assinar.html');
                }
                if(isLicenseExpired(error.data.message)) {
                    return window.location.assign('/reativar2.html');
                }
                new notificationService()
                    .type('error')
                    .message(getConstants(error.data.message))
                    .title('ERRO!')
                    .notify();
                
                this.success = false;
            }
        },
        reset(form) {
            form.target.reset();
            // this.form = {};
            this.errors = {};
            this.submitDisabled = false;
        },
        notify(type, message, title)  {
            new notificationService()
                .type(type)
                .message(message)
                .title(title)
                .notify()
        },
        async submitForgotPassword() {
            if (!this.forgot.identifier) {
                return this.notify('error', 'Informe seu login ou e-mail.', 'ERRO!');
            }

            try {
                this.forgotDisabled = true;
                await authService.requestPasswordReset(this.forgot.identifier);
                this.notify('success', getConstants('PASSWORD_RESET_EMAIL_SENT'), 'SUCESSO!');
                this.forgot.identifier = '';
                this.forgotMode = false;
            } catch (error) {
                this.notify('error', getConstants(error.data.message), 'ERRO!');
            } finally {
                this.forgotDisabled = false;
            }
        },
        async submitResetPassword() {
            if (!this.resetForm.password || !this.resetForm.passwordConfirm) {
                return this.notify('error', 'Preencha os campos de nova senha.', 'ERRO!');
            }

            if (this.resetForm.password !== this.resetForm.passwordConfirm) {
                return this.notify('error', getConstants('PASSWORD_CONFIRM_MISMATCH'), 'ERRO!');
            }

            try {
                this.resetDisabled = true;
                await authService.resetPassword(this.resetToken, this.resetForm.password, this.resetForm.passwordConfirm);
                this.notify('success', getConstants('PASSWORD_RESET_SUCCESS'), 'SUCESSO!');
                this.resetForm.password = '';
                this.resetForm.passwordConfirm = '';
                this.resetMode = false;

                const url = new URL(window.location.href);
                url.searchParams.delete('reset_token');
                window.history.replaceState({}, document.title, url.pathname + url.search);
            } catch (error) {
                this.notify('error', getConstants(error.data.message), 'ERRO!');
            } finally {
                this.resetDisabled = false;
            }
        },
        enableForgotMode() {
            this.resetMode = false;
            this.forgotMode = true;
        },
        backToLogin() {
            this.forgotMode = false;
            this.resetMode = false;
            this.forgot.identifier = '';
            this.resetForm.password = '';
            this.resetForm.passwordConfirm = '';
        }
    },
    created: async function() {
        const params = new URLSearchParams(window.location.search);
        const resetToken = params.get('reset_token');
        if (resetToken) {
            this.resetToken = resetToken;
            this.resetMode = true;
            this.forgotMode = false;
        }
    }
};
</script>
<template>
<section class="login-page">
    <div class="login-shell">
        <aside v-if="!forgotMode && !resetMode" class="marketing-panel" aria-label="Conheça o PREVID">
            <div class="marketing-inner">
                <div class="marketing-logo">
                    <img src="includes/imgs/logo_menu.png" alt="PREVID"/>
                </div>
                
                <h2>Precisão técnica com produtividade no dia a dia do escritório.</h2>
                <p class="lead">
                    Estruture seus cálculos com mais consistência, reduza retrabalho e entregue análises
                    com mais segurança para o cliente.
                </p>

                <div class="proof-box">
                    <strong>Mais de 1 milhão de cálculos realizados</strong>
                    <span>Plataforma utilizada diariamente por profissionais de todo o país.</span>
                </div>

                <p class="lead">
                    Fluxo pensado para prática previdenciária real
                </p>
                <p class="lead">
                    Atualizações contínuas das regras de cálculo
                </p>
            </div>
        </aside>

        <p-card class="login-card">
            <div class="brand-block">
                <h1 v-if="!forgotMode && !resetMode">Acesse sua conta</h1>
                <h1 v-if="forgotMode">Esqueceu sua senha?</h1>
                <h1 v-if="resetMode">Redefinir senha</h1>
                <p  v-if="!forgotMode && !resetMode" class="subtitle">Entre para continuar seus cálculos previdenciários no PREVID.</p>
            </div>

            <form v-if="!forgotMode && !resetMode" action="" @submit.prevent="submit" class="" novalidate>
                <div class="fields">
                    <hr class="separator bg-primary"/>
                    <div class="">
                        <p-input required="true" minlength="3" name="user" label="Usuário" type="text" :error="errors['user']" v-model="form.login"></p-input>
                    </div>

                    <div class="">
                        <p-input required="true" minlength="3" label="Senha" name="password" type="password" :error="errors['password']" v-model="form.password"></p-input>
                    </div>
                </div>
                <div class="footer d-flex justify-content-center align-items-center">
                    <button type="submit" :disabled="submitDisabled" class="btn btn-primary p-2 w-100" name="button" title="Cadastrar"><span class="text">Entrar</span></button>
                </div>
                <div class="actions">
                    <a href="#" @click.prevent="enableForgotMode">Esqueci minha senha</a>
                </div>
            </form>

            <form v-if="forgotMode" action="" @submit.prevent="submitForgotPassword" novalidate>
                <div class="fields">
                    <hr class="separator bg-primary"/>
                    <p class="helper-text">Informe seu login ou e-mail para receber um link de redefinição de senha.</p>
                    <div class="">
                        <p-input required="true" minlength="3" name="identifier" label="Login ou e-mail" type="text" v-model="forgot.identifier"></p-input>
                    </div>
                </div>
                <div class="footer d-flex justify-content-center align-items-center">
                    <button type="submit" :disabled="forgotDisabled" class="btn btn-primary p-2 w-100"><span class="text">Enviar link</span></button>
                </div>
                <div class="actions">
                    <a href="#" @click.prevent="backToLogin">Voltar ao login</a>
                </div>
            </form>

            <form v-if="resetMode" action="" @submit.prevent="submitResetPassword" novalidate>
                <div class="fields">
                    <hr class="separator bg-primary"/>
                    <p class="helper-text">Crie sua nova senha com pelo menos 8 caracteres, letras e números.</p>
                    <div class="">
                        <p-input required="true" minlength="8" name="new-password" label="Nova senha" type="password" v-model="resetForm.password"></p-input>
                    </div>
                    <div class="">
                        <p-input required="true" minlength="8" name="password-confirm" label="Confirmar nova senha" type="password" v-model="resetForm.passwordConfirm"></p-input>
                    </div>
                </div>
                <div class="footer d-flex justify-content-center align-items-center">
                    <button type="submit" :disabled="resetDisabled" class="btn btn-primary p-2 w-100"><span class="text">Redefinir senha</span></button>
                </div>
                <div class="actions">
                    <a href="#" @click.prevent="backToLogin">Voltar ao login</a>
                </div>
            </form>
        </p-card>
    </div>
</section>
</template>
<style lang="scss">

:root {
    --login-bg-1: #e7f2fb;
    --login-bg-2: #fdf8ef;
    --login-accent: #1c5fa8;
    --login-accent-hover: #174d89;
    --login-text: #243648;
    --login-subtext: #58708a;
}

.p-input > .inner {
    height: 55px;
}
.p-card {
    box-shadow: none;
    border: none;
}

.login-page {
    position: relative;
    min-height: 100vh;
    width: 100%;
    padding: 22px;
    display: flex;
    justify-content: center;
    align-items: center;
    background:
        linear-gradient(140deg, rgba(8, 39, 71, 0.92), rgba(20, 85, 135, 0.9)),
        radial-gradient(circle at 85% 12%, rgba(255, 215, 145, 0.25), transparent 42%),
        radial-gradient(circle at 10% 85%, rgba(125, 209, 255, 0.18), transparent 44%);
}

.login-shell {
    position: relative;
    width: 100%;
    max-width: 1020px;
    display: flex;
    justify-content: center;
    gap: 18px;

    @media screen and (min-width: 62em) {
        grid-template-columns: minmax(380px, 1fr) minmax(360px, 420px);
        align-items: center;
    }
}

.login-card {
    padding: 30px 24px;
    width: 100%;
    margin: 0 auto;
    max-width: 400px;
    border-radius: 16px;
    background-color: #ffffff;
    box-shadow: 0 18px 42px rgba(7, 28, 48, 0.24);

    @media screen and (min-width: 40em) {
        padding: 34px 30px;
    }

    @media screen and (min-width: 62em) {
        order: 2;
        justify-self: end;
    }
}

.brand-block {
    h1 {
        font-family: 'Montserrat', sans-serif;
        font-weight: 700;
        font-size: 28px;
        line-height: 1.1;
        color: var(--login-text);
        text-align: center;
        margin-bottom: 8px;
    }

    .subtitle {
        text-align: center;
        color: var(--login-subtext);
        margin-bottom: 10px;
        font-size: 15px;
    }
}

.marketing-panel {
    color: #f5f9ff;
    background: transparent;
    display: none;
    max-width: 460px;

    @media screen and (min-width: 62em) {
        display: block;
        order: 1;
    }
}

.marketing-inner {
    height: 100%;
    padding: 10px 40px;
    display: flex;
    flex-direction: column;

    h2 {
        font-family: 'Montserrat', sans-serif;
        font-weight: 500;
        font-size: 28px;
        line-height: 1.2;
        margin-bottom: 24px;
        color: #ffffff;
    }
}

.marketing-logo {
    margin-bottom: 24px;

    img {
        width: 220px;
        max-width: 100%;
        display: block;
    }
}

.eyebrow {
    display: inline-flex;
    align-items: center;
    width: fit-content;
    font-family: 'Montserrat', sans-serif;
    font-weight: 700;
    font-size: 10px;
    text-transform: uppercase;
    letter-spacing: 1px;
    padding: 6px 10px;
    border-radius: 999px;
    margin-bottom: 14px;
    color: #d4e8fb;
    background-color: rgba(222, 240, 255, 0.15);
}

.lead {
    color: rgba(233, 243, 255, 0.92);
    font-size: 14px;
    line-height: 1.5;
    margin-bottom: 14px;
}

.proof-box {
    border-radius: 12px;
    padding: 12px;
    margin-bottom: 14px;
    background-color: rgba(255, 255, 255, 0.08);
    border: 1px solid rgba(255, 255, 255, 0.12);

    strong {
        display: block;
        // font-family: 'Montserrat', sans-serif;
        font-size: 15px;
        // font-weight: 500;
        color: #ffffff;
        margin-bottom: 2px;
    }

    span {
        font-size: 12px;
        color: rgba(232, 243, 255, 0.9);
    }
}

.marketing-list {
    margin: 0;
    padding-left: 18px;
    display: grid;
    gap: 8px;

    li {
        color: rgba(235, 244, 255, 0.92);
        font-size: 13px;
    }
}

@media screen and (max-width: 61.99em) {
    .login-card {
        max-width: 430px;
    }
}

.footer .btn {
    border: none;
    border-radius: 12px;
    background-color: var(--login-accent);
    font-weight: 700;
    letter-spacing: 0.2px;
    transition: transform 0.2s ease, background-color 0.2s ease, box-shadow 0.2s ease;

    &:hover:enabled {
        background-color: var(--login-accent-hover);
        transform: translateY(-1px);
        box-shadow: 0 10px 18px rgba(28, 95, 168, 0.22);
    }

    &:disabled {
        opacity: 0.6;
        cursor: not-allowed;
    }
}

.p-card {
    h2, p {
        text-align: center;
    }
}

.separator {
    width: 84px;
    height: 4px;
    border-radius: 4px;
    margin: 8px auto 12px;
    background-color: #2a6eb7;
}

.actions {
    text-align: center;
    margin-top: 16px;

    a {
        color: #2a5e98;
        font-size: 14px;
        text-decoration: none;
        border-bottom: 1px solid rgba(42, 94, 152, 0.45);
        transition: color 0.2s ease, border-color 0.2s ease;

        &:hover {
            color: #163f69;
            border-color: #163f69;
        }
    }
}

.helper-text {
    text-align: center;
    font-size: 14px;
    color: #445e77;
    margin-bottom: 12px;
}
</style>



// WEBPACK FOOTER //
// src/js/pages/login.vue